import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { selectedOptic, formatValueUnit } from "../js/utils";
import { rightStyle, sortFunction } from "../js/tableColumns";
import "../css/ProductStockList.css";

export default function ProductStockList(props) {
  const [stockList, setStockList] = useState([]);

  const columns = [
    {
      name: "Nombre óptica",
      selector: (row) => row.nombreOptica,
      sortable: false,
      width: "70%",
    },
    {
      name: "Stock",
      selector: (row) => formatValueUnit(row.stock),
      sortable: false,
      width: "auto",
      style: rightStyle,
      sortFunction: (rowA, rowB) => sortFunction(rowA.stock, rowB.stock),
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.nombreOptica === selectedOptic.nombre,
      style: {
        backgroundColor: "#dbf2fe",
      },
    },
  ];

  useEffect(() => {
    setStockList(props.stockList);
  }, [props]);

  return (
    <div className="product-stock-list-container">
      <DataTable
        columns={columns}
        data={stockList}
        className="custom-datatable"
        noDataComponent="No hay datos disponibles."
        conditionalRowStyles={conditionalRowStyles}
        onRowClicked={async (row) => {}}
      />
    </div>
  );
}
